const wholeCountryLocations = ['cela-cr', 'cela-sr', 'cala-polska'];

export function isWholeCountryLocation(location) {
    return wholeCountryLocations.includes(location);
}

export function suggestedRadiusForLocation(location) {
    if (location === 'praha' || isWholeCountryLocation(location)) {
        return 0;
    }
    if (['brno', 'ostrava', 'plzen', 'liberec', 'olomouc'].includes(location)) {
        return 10;
    }
    if (['ceske-budejovice', 'usti-nad-labem', 'hradec-kralove', 'pardubice'].includes(location)) {
        return 20;
    }
    return 30;
}
